export var ASSETS_CDN_URL = 'https://cdn.uc.assets.prezly.com';
export var ASSETS_SECONDARY_CDN_URL = 'https://ucarecdn.com';
export var DEFAULT_PAGE_SIZE = 12;
export var DEFAULT_GALLERY_PAGE_SIZE = 6;
export var OG_IMAGE_API_URL = 'https://og.prezly.com/api/og';
export var PRIVACY_PORTAL_URL = 'https://privacy.prezly.com';